export const StaticTextFields = {
    "hy": {
        "default-title": "ՀՀ ԱՆ Քրեակատարողական ծառայություն",
        "default-description": "ՀՀ ԱՆ Քրեակատարողական ծառայություն",
        "header-ministry-name": "Հայաստանի Հանրապետության Արդարադատության Նախարարության",
        "header-website-name": "ՔՐԵԱԿԱՏԱՐՈՂԱԿԱՆ ԾԱՌԱՅՈՒԹՅՈՒՆ",
        "header-search-placeholder": "Փնտրել",
        "director-button-text": "Կարդալ ավելին ",
        "right-menu-button-text": "Թափուր աշխատատեղեր",
        "home-news-section-title": "Նորություններ",
        "home-news-link-text": "Բոլոր նորությունները",
        "home-videos-section-title": "Տեսադարան",
        "home-videos-link-text": "Բոլոր տեսանյութերը",
        "home-questions-title-text": "Եթե ունեք հարցեր,",
        "home-questions-description-text": "Ցանկանում եք մանրամասն տեղեկություններ ստանալ ﬔր ծառայությունների մասին",
        "home-questions-button-text": "Հետադարձ կապ",
        "news-page-title": "Նորություններ",
        "videos-page-title": "Տեսադարան",
        "search-page-title": "Փնտրել",
        "search-notFound-text": "Not found result",
        "news-details-see-more": "Կարդացեք նաև",
        "all-categories-button-text": "Բոլորը",
        "institutions-page-title": "Հիմնարկներ",
        "members-page-title": "Ղեկավարություն",
        "director-page-title": "Պետ",
        "director-greetings-text": "Հարգելի՛ հայրենակիցներ, ողջունում եմ ձեզ քրեակատարողական ծառայության պաշտոնական կայքէջում:\n\nՔրեակատարողական ծառայությունը պատժի նպատակների կատարումն ապահովող կարևորագույն պետական կառույց է, որը գործելով Հայաստանի Հանրապետության արդարադատության նախարարության իրավասությանը վերապահված գործունեության շրջանակներում՝ ապահովում է ոլորտային պետական քաղաքականության իրականացումը։\n\nԿայքէջը նախատեսված է ծառայելու հանրության լայն շերտերին՝ նրանց համար ավելի թափանցիկ և հասանելի դարձնելով քրեակատարողական գործունեության առանձնահատկությունները, նպաստելու հասարակության հնարավոր ներգրավվածությանը՝ դրանք առավել արդյունավետ և արդի պահանջներին համահունչ դարձնելու համար, ինչպես նաև լուսաբանելու և մեկնաբանելու ծրագրերը, որոնք ուղղված են ճաղերից այն կողմ գտնվող անձանց վերասոցիալականացմանը, հասարակության հետ նրանց կառուցողական համագործակցությանը, կրթմանն ու հետագայում հանրության համար լիարժեք անհատ ներկայանալուն և ինտեգրվելուն։\n\nՔրեակատարողական ծառայության պաշտոնական կայքէջը հանդես է գալու որպես քրեակատարողական ոլորտում առկա խնդիրների ու դրանց լուծմանը միտված ուղիների վերհանման նպատակային հարթակ:",
        "units-page-title": "Ստորաբաժանումներ",
        "contact-page-title": "Կապ",
        "contacts-name-input-label": "Անուն",
        "contacts-name-input-placeholder": "Անուն",
        "contacts-surname-input-label": "Ազգանուն",
        "contacts-surname-input-placeholder": "Ազգանուն",
        "contacts-email-input-label": "Էլ- հասցե",
        "contacts-email-input-placeholder": "Գրեք Ձեր էլ-հասցեն",
        "contacts-phone-number-input-label": "Հեռախոսահամարը",
        "contacts-phone-number-input-placeholder": "Գրեք Ձեր հեռախոսահամարը",
        "contacts-message-input-label": "Նամակ",
        "contacts-message-input-placeholder": "Գրեք Ձեր նամակը",
        "contacts-send-message-button": "Ուղարկել նամակ",
        "contacts-map-place-title": "ՔՐԵԱԿԱՏԱՐՈՂԱԿԱՆ ԾԱՌԱՅՈՒԹՈՒՆ",
        "contacts-telephone": "Թեժ գիծ՝",
        "contacts-voice-portal": "Ձայնային պորտալ՝",
        "contacts-email": "Էլ- հասցե՝",
        "contacts-address": "Հասցե՝",
        "contacts-error-message": "Խնդրում ենք փորձել մի փոքր ուշ",
        "footer-news-categories-title": "Նորություններ",
        "footer-contacts-title": "Հետադարձ կապ",
        "footer-contacts-telephone": "Թեժ գիծ՝",
        "footer-contacts-voice-portal": "Ձայնային պորտալ՝",
        "footer-contacts-email": "Էլ- հասցե՝",
        "footer-contacts-address": "Հասցե՝",
        "footer-description": "ՀՀ արդարադատության նախարարության քրեակատարողական ծառայություն",
        "footer-developed-by": "Developed By",
        "page-notFound-text": "Oops, Page not found",
        "news-notFound-text": "News is this language is not found"
    },
    "ru": {
        "default-title": "ՀՀ ԱՆ Քրեակատարողական ծառայություն",
        "default-description": "ՀՀ ԱՆ Քրեակատարողական ծառայություն",
        "header-ministry-name": "Министерство Юстиции Республики Армения",
        "header-website-name": "УГОЛОВНО-ИСПОЛНИТЕЛЬНАЯ СЛУЖБА",
        "header-search-placeholder": "Искать",
        "director-button-text": "Подробнее",
        "right-menu-button-text": "Вакансии",
        "home-news-section-title": "Новости",
        "home-news-link-text": "Все новости",
        "home-videos-section-title": "Видео",
        "home-videos-link-text": "Все видео",
        "home-questions-title-text": "Եթե ունեք հարցեր,",
        "home-questions-description-text": "Ցանկանում եք մանրամասն տեղեկություններ ստանալ ﬔր ծառայությունների մասին",
        "home-questions-button-text": "Контакты",
        "news-page-title": "Новости",
        "news-details-see-more": "Читайте также",
        "videos-page-title": "Видео",
        "search-page-title": "Search",
        "search-notFound-text": "Not found result",
        "all-categories-button-text": "Все",
        "institutions-page-title": "Учреждения",
        "members-page-title": "Руководство",
        "director-page-title": "Начальник",
        "director-greetings-text": "Уважаемые соотечественники, приветствую вас на официальном сайте уголовно-исполнительной службы.\n\nУголовно-исполнительная служба является обеспечивающей исполнение целей наказания важнейшей государственной структурой, которая осуществляет государственную политику в сферах компетенции Министерства юстиции Республики Армения.\n\nСайт предусмотрен для широких слоев общественности с целью более прозрачного и доступного представления особенностей деятельности уголовно-исполнительной системы, для возможного вовлечения общества с тем, чтобы сделать их наиболее эффективными и отвечающими современным требованиям, а также предназначен для освещения и интерпретации проектов, направленных на ресоциализацию находящихся за решеткой лиц, на их конструктивное взаимодействие с обществом, обучение и дальнейшую интеграцию как  полноценных членов общества.\n\nОфициальный сайт уголовно-исполнительной службы будет выступать в качестве целевой платформы для выявления присутствующих в уголовно-исполнительной сфере проблем и путей, направленных на их решение.\n",
        "units-page-title": "Подразделения",
        "contact-page-title": "Связь",
        "contacts-name-input-label": "Имя",
        "contacts-name-input-placeholder": "Имя",
        "contacts-surname-input-label": "Фамилия",
        "contacts-surname-input-placeholder": "Фамилия",
        "contacts-email-input-label": "Электронная почта",
        "contacts-email-input-placeholder": "Введите адрес электронной почты",
        "contacts-phone-number-input-label": "Номер телефона",
        "contacts-phone-number-input-placeholder": "Введите номер телефона ",
        "contacts-message-input-label": "Сообщение",
        "contacts-message-input-placeholder": "Напишите сообщение",
        "contacts-send-message-button": "Отправить сообщение",
        "contacts-map-place-title": "УГОЛОВНО-ИСПОЛНИТЕЛЬНАЯ СЛУЖБА",
        "contacts-telephone": "Горячая линия:",
        "contacts-voice-portal": "Голосовой портал:",
        "contacts-email": "Электронная почта:",
        "contacts-address": "Адрес: пр. Аршакуняц, 63, г. Ереван",
        "contacts-error-message": "Пожалуйста попробуйте попозже",
        "footer-news-categories-title": "Новости",
        "footer-contacts-title": "Контакты",
        "footer-contacts-telephone": "Горячая линия:",
        "footer-contacts-voice-portal": "Голосовой портал:",
        "footer-contacts-email": "Электронная почта:",
        "footer-contacts-address": "Адрес:",
        "footer-description": "Уголовно-исполнительная служба Министерства Юстиции РА ",
        "footer-developed-by": "Developed By",
        "page-notFound-text": "Oops, Page not found",
        "news-notFound-text": "News is this language is not found"
    },
    "en": {
        "default-title": "Ministry of Justice of the Republic of Armenia",
        "default-description": "ՀՀ ԱՆ Քրեակատարողական ծառայություն",
        "header-ministry-name": "Ministry of Justice of the Republic of Armenia",
        "header-website-name": "PENITENTIARY SERVICE",
        "header-search-placeholder": "Search",
        "director-button-text": "Read more",
        "right-menu-button-text": "Vacancies",
        "home-news-section-title": "Նորություններ",
        "home-news-link-text": "Բոլոր նորությունները",
        "home-videos-section-title": "Տեսադարան",
        "home-videos-link-text": "Բոլոր տեսանյութերը",
        "home-questions-title-text": "Եթե ունեք հարցեր,",
        "home-questions-description-text": "Ցանկանում եք մանրամասն տեղեկություններ ստանալ ﬔր ծառայությունների մասին",
        "home-questions-button-text": "Հետադարձ կապ",
        "news-page-title": "News",
        "news-details-see-more": "Կարդացեք նաև",
        "videos-page-title": "Տեսադարան",
        "search-page-title": "Search",
        "search-notFound-text": "Not found result",
        "all-categories-button-text": "All",
        "institutions-page-title": "Հիմնարկներ",
        "members-page-title": "Ղեկավարություն",
        "director-page-title": "Director",
        "director-greetings-text": "Հարգելի՛ հայրենակիցներ, ողջունում եմ ձեզ քրեակատարողական ծառայության պաշտոնական կայքէջում",
        "units-page-title": "Ստորաբաժանումներ",
        "contact-page-title": "Contact",
        "contacts-name-input-label": "Անուն",
        "contacts-name-input-placeholder": "Անուն",
        "contacts-surname-input-label": "Ազգանուն",
        "contacts-surname-input-placeholder": "Ազգանուն",
        "contacts-email-input-label": "Էլ- հասցե",
        "contacts-email-input-placeholder": "Գրեք Ձեր էլ-հասցեն",
        "contacts-phone-number-input-label": "Հեռախոսահամարը",
        "contacts-phone-number-input-placeholder": "Գրեք Ձեր հեռախոսահամարը",
        "contacts-message-input-label": "Նամակ",
        "contacts-message-input-placeholder": "Գրեք Ձեր նամակը",
        "contacts-send-message-button": "Ուղարկել նամակ",
        "contacts-map-place-title": "ՔՐԵԱԿԱՏԱՐՈՂԱԿԱՆ ԾԱՌԱՅՈՒԹՈՒՆ",
        "contacts-telephone": "Թեժ գիծ՝",
        "contacts-voice-portal": "Ձայնային պորտալ՝",
        "contacts-email": "Email՝",
        "contacts-address": "Հասցե՝",
        "contacts-error-message": "Please, try later",
        "footer-news-categories-title": "Նորություններ",
        "footer-contacts-title": "Հետադարձ կապ",
        "footer-contacts-telephone": "Hot line՝",
        "footer-contacts-voice-portal": "Voice portal՝",
        "footer-contacts-email": "Email՝",
        "footer-contacts-address": "Address՝",
        "footer-description": "ՀՀ Արդարադատության Նախարարություն Քրեակատարողական Ծառայություն",
        "footer-developed-by": "Developed By",
        "page-notFound-text": "Oops, Page not found",
        "news-notFound-text": "News is this language is not found"
    }
}
